<template>
<div class="chapter">
<div class="inner_page">
<div class="figbody">
<span epub:type="pagebreak" id="pagevi" title="vi"></span><img src="Images/Intro_001_9780062950741.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Image001.vue?a0d2254e